<app-doc [section]="'intro'"></app-doc>



<!--####################################################################-->
<app-doc [section]="'direct'"></app-doc>

<app-circle></app-circle>
<app-circle [color]="'red'"></app-circle>
<app-circle [color]="'orange'"></app-circle>



<!--####################################################################-->
<app-doc [section]="'container'"></app-doc>

<div #containerDiv></div>
<br>
<button (click)="switchFirst()">switch first</button>
<button (click)="removeLast()">remove last</button>
<button (click)="cycleLeft()" *ngIf="numberOfCircles == 3">cycle left</button>
number of circles: {{numberOfCircles}}



<!--####################################################################-->
<app-doc [section]="'toggle'"></app-doc>

<div class="shape-wrapper" (click)="toggleShape()">
  <div *ngComponentOutlet="shapeComponent" ></div>
</div>

<div class="shape-wrapper" (click)="toggleShape()">
  <ng-template [ngComponentOutlet]="shapeComponent"></ng-template>
</div>
